import { AlgChannelService } from "./channel.service";
import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { ApiVisa } from '../../../shared/api-visa.model';
import { Core2Config } from "../../../shared";

@Injectable({ providedIn: "root" })
export class FacebookService extends AlgChannelService {

  constructor(httpClient: HttpClient) {
    super();
    this.apiUrl =  Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ALG_CC_MODULE + "facebook/messenger-api/send";
    this.endpointPath = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ALG_CC_MODULE + "facebook/messenger-api/send";
    this.httpClient = httpClient;
  }

  broadcastFacebook(data: any, apiVisa: ApiVisa) {
    let url = this.apiUrl + '/broadcast';
    return this.httpClient.post(
      url,
      data,
      this.getHttpHeader(apiVisa)
    );
  }
}
